import declare from "dojo/_base/declare";
import domClass from "dojo/dom-class";
import query from "dojo/query";
import stateColorResolver from "csi/heading/stateColorResolver";
import html from "csi/html";
import StateWidget from "csi/html/StateWidget";
import locale from "csi/locale";
import xml from "csi/xml";

const ProjectStateHeaderView = declare(StateWidget, {
	/**
	 * @override
	 * Apply styling for active state
	 */
	_processHtml: function(ctx, dom) {
		this.inherited(arguments);

		const node = ctx.getNode();
		const css = stateColorResolver.getStateCss(node);
		const stateEnumValue = xml.enumGetText(node.State);

		var eCanceled = query(".canceled", dom)[0];
		if (eCanceled) {
			html.text(eCanceled, locale.getEnumName("ProjectState:Canceled", true));
			domClass.add(eCanceled, css);
		} else {
			var eDraft = query(".draft", dom)[0];
			var eInProgress = query(".inprogress", dom)[0];
			var eComplete = query(".complete", dom)[0];

			html.text(eDraft, locale.getEnumName("ProjectState:Draft", true));
			html.text(eInProgress, locale.getEnumName("ProjectState:InProgress", true));
			html.text(eComplete, locale.getEnumName("ProjectState:Complete", true));

			switch (stateEnumValue) {
				case "Draft": domClass.add(eDraft, css); break;
				case "InProgress": domClass.add(eInProgress, css); break;
				case "Complete": domClass.add(eComplete, css); break;
			}
		}
	},
});

export = ProjectStateHeaderView;
